import { render, staticRenderFns } from "./AWomanLikeNoOther2022.vue?vue&type=template&id=7fd009a0&scoped=true"
import script from "./AWomanLikeNoOther2022.vue?vue&type=script&lang=js"
export * from "./AWomanLikeNoOther2022.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fd009a0",
  null
  
)

export default component.exports